module.exports = __webpack_public_path__ + "static/media/wizard-background.0858c09d.jpg";